<div class="status-badge" [style.background-color]="backgroundColor" [style.color]="textColor">
  <span class="status-badge__dot">●</span>
  <span class="status-badge__text"> {{ text }}</span>
</div>
